import React from 'react';
import { AritoDialog, AritoForm, AritoHeaderTabs, AritoIcon, BottomActionBarV2 } from '@/components/custom/erp';
import { SearchFormValues, searchSchema } from '../../schema';
import BasicInfoTab from './BasicInfoTab';
import FilterTab from './FilterTab';
import DetailTab from './DetailTab';

interface SearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (filters: any) => void;
}

const SearchDialog = ({ open, onClose, onSearch }: SearchDialogProps) => {
  const handleSubmit = (data: SearchFormValues) => {
    onSearch(data);
    onClose();
  };

  return (
    <AritoDialog
      open={open}
      onClose={onClose}
      title='Lọc chứng từ'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={true}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoForm
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        onSubmit={handleSubmit}
        className='w-[800px]'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] overflow-y-auto'>
            <BasicInfoTab formMode='add' />

            <AritoHeaderTabs
              tabs={[
                {
                  id: 'detail',
                  label: 'Chi tiết',
                  component: <DetailTab formMode='add' />
                }
              ]}
              className='border-b border-b-gray-200'
            />

            <FilterTab formMode='add' />
          </div>
        }
        bottomBar={<BottomActionBarV2 onClose={onClose} mode='add' />}
      />
    </AritoDialog>
  );
};

export default SearchDialog;
